export type McpChatOnboardingStepId = 1 | 2 | 3;

const MCP_CHAT_CONSENT_STORAGE_KEY = 'mizfa.mcpChat.onboardingConsent.v1';
const MCP_CHAT_ENTERED_STORAGE_KEY = 'mizfa.mcpChat.onboardingEntered.v1';

/** Legacy localStorage — used only once to migrate into MCP DB. */
export function readLegacyMcpChatOnboardingLocal(): {
  consentAccepted: boolean;
  entered: boolean;
} {
  try {
    return {
      consentAccepted:
        localStorage.getItem(MCP_CHAT_CONSENT_STORAGE_KEY) === '1',
      entered: localStorage.getItem(MCP_CHAT_ENTERED_STORAGE_KEY) === '1'
    };
  } catch {
    return { consentAccepted: false, entered: false };
  }
}

export function clearLegacyMcpChatOnboardingLocal(): void {
  try {
    localStorage.removeItem(MCP_CHAT_CONSENT_STORAGE_KEY);
    localStorage.removeItem(MCP_CHAT_ENTERED_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export const MCP_CHAT_ONBOARDING_STEPS: Array<{
  id: McpChatOnboardingStepId;
  label: string;
  title: string;
}> = [
  {
    id: 1,
    label: 'شرایط استفاده',
    title: 'شرایط استفاده از چت'
  },
  {
    id: 2,
    label: 'کلید API',
    title: 'ثبت کلید API'
  },
  {
    id: 3,
    label: 'کیف پول AI',
    title: 'شارژ اعتبار AI'
  }
];
